export default __webpack_public_path__ + "fr/static/media/personnal-account-desk.84b66524.jpg";